import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import {language} from '../../language/vn';
import {ChucVuComponent} from '../danhmuc/chucvu/chucvu.component';
import {DoKhanComponent} from '../danhmuc/dokhan/dokhan.component';
import {DoMatComponent} from '../danhmuc/domat/domat.component';
import {DonViNgoaiComponent} from '../danhmuc/donvingoai/donvingoai.component';
import {DonViNoiBoComponent} from '../danhmuc/donvinoibo/donvinoibo.component';
import {LinhVucVanBanComponent} from '../danhmuc/linhvucvanban/linhvucvanban.component';
import {LoaiKeHoachComponent} from '../danhmuc/loaikehoach/loaikehoach.component';
import {LoaiVanBanComponent} from '../danhmuc/loaivanban/loaivanban.component';
import {NhomMauVanBanComponent} from '../danhmuc/nhommauvanban/nhommauvanban.component';
import {NhomTinTucComponent} from '../danhmuc/nhomtintuc/nhomtintuc.component';
import {ThietBiComponent} from '../danhmuc/thietbi/thietbi.component';
import {LoaiPhongComponent} from '../danhmuc/loaiphong/loaiphong.component';
import {ToaNhaComponent} from '../danhmuc/toanha/toanha.component';
import {PhongComponent} from '../danhmuc/phong/phong.component';
import {LichDonViComponent} from '../info/lichdonvi/lichdonvi.component';
import {SoVanThuComponent} from '../info/sovanthu/sovanthu.component';
import {HoSoCaNhanComponent} from '../info/hoso/canhan/canhan.component';
import {HoSoDonViComponent} from '../info/hoso/donvi/donvi.component';
import {VanBanPhapQuyComponent} from '../info/vanbanphapquy/vanbanphapquy.component';
import {MauVanBanComponent} from '../info/mauvanban/mauvanban.component';
import {KeHoachComponent} from '../info/kehoach/kehoach.component';
import {GiaiQuyetSuVuComponent} from '../info/giaiquyetsuvu/giaiquyetsuvu.component';
import {VanBanDenComponent} from '../info/vanbanden/vanbanden.component';
import {VanBanDiComponent} from '../info/vanbandi/vanbandi.component';
import {EgovMainComponent} from './main.component';
import {EmailComponent} from '../info/email/email.component';
import {EgovLoginComponent} from './login/login.component';
import {AuthCanActiveService} from '../../service/login/service-authentiion';
import {LichCaNhanComponent} from '../info/lichcanhan/lichcanhan.component';
import {ViewNewsComponent} from '../info/news/viewnews.component';
import {VPPDangKyComponent} from '../info/vpp/dangky.component';
import {VPPXemKQDangKyComponent} from '../info/vpp/xemkq.component';
import {VPPDuyetDangKyComponent} from '../info/vpp/duyet.component';
import {DangKyPhongHopComponent} from '../info/phonghop/phonghop.component';
import {XemKQDangKyPhongComponent} from '../info/phonghop/xemkq.component';
import {DuyetDangKyPhongComponent} from '../info/phonghop/duyet.component';
import {LichCongTacComponent} from '../info/lichcongtac/lichcongtac.component';
import {DSNguoiDungComponent} from '../info/users/ds.component';
import {StaffsComponent} from '../info/users/staffs.component';
import {RolesComponent} from '../info/role/role.component';
import {DSUsersComponent} from '../info/users/user.component';
import {WorkGroupComponent} from '../info/workgroup/workgroup.component';
import {VanBanDenPhoCapComponent} from '../info/vanbanden/vanbanphocap/vanbanphocap.component';
import {HoTroComponent} from '../info/hotro/hotro.component';
import {FolderComponent} from '../info/folder/folder.component';
import {HoSoLuuTruComponent} from '../info/hoso/luutru/luutru.component';
import {SearchComponent} from '../info/search/search.component';
import {LogEgovComponent} from '../info/log/log.component';
import {FunctionComponent} from '../info/permission/view.component';
import {EgovMainListComponent} from './mainlist.component';
import {ErrorPermissionComponent} from '../info/permission/error.component';
import {DocThongBaoComponent} from '../info/thongbao/docthongbao.component';

const routes: Routes = [
  {
    path: '',
    data: {
      title: language.danhmuc
    },
    canActivate: [AuthCanActiveService],
    children: [
      {
        path: 'chucvu',
        component: ChucVuComponent,
        data: {
          title: language.chucvu
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'dokhan',
        component: DoKhanComponent,
        data: {
          title: language.dokhan
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'domat',
        component: DoMatComponent,
        data: {
          title: language.domat
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'donvingoai',
        component: DonViNgoaiComponent,
        data: {
          title: language.donvingoai
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'donvinoibo',
        component: DonViNoiBoComponent,
        data: {
          title: language.donvinoibo
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'linhvucvanban',
        component: LinhVucVanBanComponent,
        data: {
          title: language.linhvucvanban
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'loaikehoach',
        component: LoaiKeHoachComponent,
        data: {
          title: language.loaikehoach
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'loaivanban',
        component: LoaiVanBanComponent,
        data: {
          title: language.loaivanban
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'nhomtintuc',
        component: NhomTinTucComponent,
        data: {
          title: language.nhomtintuc
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'nhommauvanban',
        component: NhomMauVanBanComponent,
        data: {
          title: language.nhommauvanban
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'thietbi',
        component: ThietBiComponent,
        data: {
          title: language.thietbi
        },
        canActivate: [AuthCanActiveService]
      }
    ]
  },
  {
    path: '',
    data: {
      title: language.chucnangchung
    },
    canActivate: [AuthCanActiveService],
    children: [
      {
        path: 'lichcongtac',
        component: LichCongTacComponent,
        data: {
          title: language.lichcongtac
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'lichdonvi',
        component: LichDonViComponent,
        data: {
          title: language.lichdonvi
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'lichcanhan',
        component: LichCaNhanComponent,
        data: {
          title: language.lichcanhan
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'kehoach',
        component: KeHoachComponent,
        data: {
          title: language.kehoach
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'danhsachnguoisudung',
        component: DSNguoiDungComponent,
        data: {
          title: language.danhsachnguoisudung
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'docthongbao',
        component: DocThongBaoComponent,
        data: {
          title: language.docthongbao
        },
        canActivate: [AuthCanActiveService]
      }
    ]

  },
  {
    path: '',
    data: {
      title: language.admin
    },
    canActivate: [AuthCanActiveService],
    children: [
      {
        path: 'danhmucsovanthu',
        component: SoVanThuComponent,
        data: {
          title: language.dmsovanthu
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'danhsachnguoidung',
        component: StaffsComponent,
        data: {
          title: language.danhsachnguoidung
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'phanquyen',
        component: RolesComponent,
        data: {
          title: language.phanquyen
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'cauhinhquyenhan',
        component: FunctionComponent,
        data: {
          title: language.cauhinhquyenhan
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'danhsachtaikhoan',
        component: DSUsersComponent,
        data: {
          title: language.danhsachtaikhoan
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'lichsu',
        component: LogEgovComponent,
        data: {
          title: language.lichsusudung
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'support',
        component: HoTroComponent,
        data: {
          title: language.hotro
        },
        canActivate: [AuthCanActiveService]
      }

    ]

  },
   {
    path: '',
     data: {
       title: language.hosocongviec
     },
     canActivate: [AuthCanActiveService],
    children: [
      {
        path: 'hosocanhan',
        component: HoSoCaNhanComponent,
        data: {
          title: language.hosocanhan
        },
        canActivate: [AuthCanActiveService]
      }, {
        path: 'hosodonvi',
        component: HoSoDonViComponent,
        data: {
          title: language.hosodonvi
        },
        canActivate: [AuthCanActiveService]
      }, {
        path: 'hosoluutru',
        component: HoSoLuuTruComponent,
        data: {
          title: language.hoso_drive
        },
        canActivate: [AuthCanActiveService]
      }, {
        path: 'thumucluutru',
        component: FolderComponent,
        data: {
          title: language.thumucluutru
        },
        canActivate: [AuthCanActiveService]
      }

    ]

  },
  {
    path: '',
    data: {
      title: language.tainguyen
    },
    canActivate: [AuthCanActiveService],
    children: [
      {
        path: 'vanbanphapquy',
        component: VanBanPhapQuyComponent,
        data: {
          title: language.vanbanphapquy
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'vanbanphocap',
        component: VanBanDenPhoCapComponent,
        data: {
          title: language.vanbanphocap
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'mauvanban',
        component: MauVanBanComponent,
        data: {
          title: language.mauvanban
        },
        canActivate: [AuthCanActiveService]
      }
    ]

  },
  {
    path: 'qlsuvu',
    component: GiaiQuyetSuVuComponent,
    data: {
      title: language.giaiquyetsuvu
    },
    canActivate: [AuthCanActiveService],
    children: [
      {
        path: 'qlsuvu',
        component: GiaiQuyetSuVuComponent,
        data: {
          title: language.tonghop
        },
        canActivate: [AuthCanActiveService]
      }
    ]

  },
  {
    path: '',
    data: {
      title: language.news
    },
    canActivate: [AuthCanActiveService],
    children: [
      {
        path: 'index',
        component: ViewNewsComponent,
        data: {
          title: language.news
        },
        canActivate: [AuthCanActiveService]
      }
    ]

  },
  {
    path: 'qlvanbanden',
    component: VanBanDenComponent,
    data: {
      title: language.vanbanden
    },
    canActivate: [AuthCanActiveService]
    ,
    children: [
      {
        path: 'qlvanbanden',
        component: VanBanDenComponent,
        data: {
          title: language.tonghop
        },
        canActivate: [AuthCanActiveService]
      }
    ]
  },
  {
    path: 'qlvanbandi',
    component: VanBanDiComponent,
    data: {
      title: language.vanbandi
    },
    canActivate: [AuthCanActiveService],
    children: [
      {
        path: 'qlvanbandi',
        component: VanBanDiComponent,
        data: {
          title: language.tonghop
        },
        canActivate: [AuthCanActiveService]
      }
    ]

  },
  {
    path: '',
    data: {
      title: language.datxe
    },
    canActivate: [AuthCanActiveService],
    children: [
      {
        path: 'theodoiyeucau',
        component: VPPDangKyComponent,
        data: {
          title: language.theodoiyeucau
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'xemketquaduyet',
        component: VPPXemKQDangKyComponent,
        data: {
          title: language.xemketquaduyet
        },
        canActivate: [AuthCanActiveService]
      }
      ,
      {
        path: 'duyetyeucau',
        component: VPPDuyetDangKyComponent,
        data: {
          title: language.duyetyeucau
        },
        canActivate: [AuthCanActiveService]
      }
    ]

  },
  {
    path: '',
    data: {
      title: language.dangkylich
    },
    canActivate: [AuthCanActiveService],
    children: [
      {
        path: 'theodoidatlich',
        component: DuyetDangKyPhongComponent,
        data: {
          title: language.theodoidatlich
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'xemketqualichphong',
        component: XemKQDangKyPhongComponent,
        data: {
          title: language.xemketqualichphong
        },
        canActivate: [AuthCanActiveService]
      }
      ,
      {
        path: 'sapxeplich',
        component: DangKyPhongHopComponent,
        data: {
          title: language.sapxeplich
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'loaiphong',
        component: LoaiPhongComponent,
        data: {
          title: language.loaiphong
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'toanha',
        component: ToaNhaComponent,
        data: {
          title: language.toanha
        },
        canActivate: [AuthCanActiveService]
      },
      {
        path: 'phong',
        component: PhongComponent,
        data: {
          title: language.phong
        },
        canActivate: [AuthCanActiveService]
      }
    ]

  },
  {
        path: '',

         canActivate: [AuthCanActiveService],
        children: [
          {
            path: 'main',
            component: EgovMainListComponent,
            canActivate: [AuthCanActiveService],
            data: {
              title: language.main
            }
          },
          {
            path: 'email',
            component: EmailComponent,
            data: {
              title: language.email
            },
            canActivate: [AuthCanActiveService]
          },
          {
            path: 'search',
            component: SearchComponent,
            data: {
              title: language.search
            },
            canActivate: [AuthCanActiveService]
          }
          ]
  },
  {
    path: '',
    data: {
      title: language.login
    },
    children: [
      {
        path: 'login',
        component: EgovLoginComponent,
        data: {
          title: language.login
        }
      }
    ]
  },
  {
    path: '',
    data: {
      title: language.nhomgui
    },
    children: [
      {
        path: 'workgroup',
        component: WorkGroupComponent,
        data: {
          title: language.nhomgui
        }
      }
    ]
  },
  {
    path: '',
    data: {
      title: 'permission'
    },
    children: [
      {
        path: 'accessdenied',
        component: ErrorPermissionComponent,
        data: {
          title: language.error_access
        }
      }
    ]
  }

];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EgovRoutingModule { }
